const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0429688,0,0,0.0429688,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497,91.982L15,91.982C6.716,91.982 0,98.698 0,106.982L0,405.018C0,413.302 6.716,420.018 15,420.018L497,420.018C505.284,420.018 512,413.302 512,405.018L512,106.982C512,98.698 505.284,91.982 497,91.982ZM30,218.508C80.073,211.808 119.826,172.055 126.526,121.982L385.473,121.982C392.173,172.055 431.926,211.808 482,218.508L482,293.492C431.926,300.192 392.173,339.945 385.473,390.018L126.526,390.018C119.826,339.945 80.073,300.192 30,293.492L30,218.508ZM482,188.119C448.502,181.94 422.042,155.48 415.862,121.982L482,121.982L482,188.119ZM96.137,121.982C89.958,155.48 63.498,181.94 30,188.119L30,121.982L96.137,121.982ZM30,323.881C63.498,330.06 89.958,356.52 96.137,390.018L30,390.018L30,323.881ZM415.862,390.018C422.041,356.52 448.502,330.06 482,323.881L482,390.018L415.862,390.018Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.775758,0,0,0.775758,69.0477,69.0424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,151C280.813,151 301,171.187 301,196C301,204.284 307.716,211 316,211C324.284,211 331,204.284 331,196C331,154.645 297.355,121 256,121C214.645,121 181,154.645 181,196L181,241L166,241C157.716,241 151,247.716 151,256C151,264.284 157.716,271 166,271L181,271C180.733,272.404 184.046,306.742 155.394,335.393C145.976,344.81 152.646,361 166,361L316,361C324.284,361 331,354.284 331,346C331,337.716 324.284,331 316,331L196.061,331C212.693,301.422 210.859,272.163 211,271L256,271C264.284,271 271,264.284 271,256C271,247.716 264.284,241 256,241L211,241L211,196C211,171.187 231.187,151 256,151Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.27c181acc585ab5a3e2b2c7ee3bf3e32.svg";
export { ForwardRef as ReactComponent };